import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import Plans from '../../components/Plans/Plans';
import { PlansSelector } from '../reducers/PlansReducer';

const mapStateToProps = state => ({
  showPlans: PlansSelector.getIsFetched(state) &&
    !isEmpty(PlansSelector.getAvailablePlans(state))
});

const PlansContainer = connect(mapStateToProps)(Plans);

export default PlansContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/PlansContainer.js
 **/